const description = {
  weiss: `é uma cerveja de trigo, pouco amarga e de coloração turva. Traz sabor e aroma de cravo e banana.`,
  stout: 'apresenta notas de chocolate amargo com leve toque de café. Sua espuma é espessa e cremosa!',
  lager: 'não é uma Lager comum. Com adição de gengibre e limão, traz uma experiência leve, refrescante e marcante!'
}

export default description;